var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isSettingsReady)?_c('card-edit',{on:{"edit":function($event){return _vm.$emit('edit')}}},[_c('order-location',{attrs:{"order":_vm.$store.getters.orderSystem.order,"divider":"","flat":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }